const TOKEN_KEY = 'user_token'
const EXPIRE_TIME_KEY = 'token_expire_time'

const state = {
  token: localStorage.getItem(TOKEN_KEY) || null,
  tokenExpireTime: parseInt(localStorage.getItem(EXPIRE_TIME_KEY)) || null,
  userInfo: null
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem(TOKEN_KEY, token)
  },
  SET_EXPIRE_TIME(state, expireTime) {
    state.tokenExpireTime = expireTime
    localStorage.setItem(EXPIRE_TIME_KEY, expireTime.toString())
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  CLEAR_AUTH(state) {
    state.token = null
    state.tokenExpireTime = null
    state.userInfo = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(EXPIRE_TIME_KEY)
  }
}

const actions = {
  login({ commit }, token) {
    const expireTime = Date.now() + 12 * 60 * 60 * 1000 // 12小时（毫秒）
    commit('SET_TOKEN', token)
    commit('SET_EXPIRE_TIME', expireTime)
  },
  logout({ commit }) {
    commit('CLEAR_AUTH')
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isAuthenticated: state => {
    const now = Date.now()
    return !!state.token && !!state.tokenExpireTime && now < state.tokenExpireTime
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}